// extracted by css-extract-rspack-plugin
export default {"hidden":"css-hidden-ef89c8","show":"css-show-19751a","tiny":"css-tiny-08cae4","small":"css-small-4c4cf3"};